<!--地址的地图展示 Sag 2020-03-26-->
<template>
  <div class="its-about-map">
    <div class="its-about-address">
      <span class="its-position-bg"></span>
      <span class="its-position">{{item.address}}</span>
      <span>{{item.postalCode}}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AboutMap',
  props: {
    item: {
      type:Object,
      default: function () {
        return {}
      }
    } 
  }
}
</script>
<style scoped>
.its-about-map{
  background: url(../../../../../public/images/about_map.png) no-repeat;
  background-position: center;
  background-size: cover;
  width: 100%;
  height: 509px;
  position: relative;
  margin-top: 75px;
}
.its-about-address{
  width: 1070px;
  margin: 0 auto;
  font-size:18px;
  font-family:PingFang SC;
  font-weight:500;
  color:rgba(63,70,106,1);
  line-height:34px;
  position: absolute;
  left: 0;
  right: 0;
  top: 23px;
}
.its-position-bg{
  display: inline-block;
  background: url(../../../../../public/images/about_position_bg.png) no-repeat;
  width: 22px;
  height: 33px;
  vertical-align: bottom;
  margin-right: 15px;
}
.its-position{
  margin-right: 50px;
}
</style>